/*
 * @Description: 专题页管理-专题页接口
 * @Author: wuxuebing
 * @Date: 2024-07-10 08:56:37
 * @LastEditors: wuxuebing
 * @LastEditTime: 2024-07-12 13:48:17
 * @FilePath: \ngs_platform_manage_admin\src\api\modules\topicPage.js
 */

import request from '../request.js'

// 专题页-分页 --- 刘志争
export const getTopicPages = function (data) {
    return request({
        url: '/userTenantCenter/getTopicPages',
        method: 'post',
        data
    })
}

// 专题页-获取所有入驻企业 --- 刘志争
export const queryTenants = function (data) {
    return request({
        url: '/userTenantCenter/queryTenants',
        method: 'post',
        data
    })
}

// 专题页-获取所有专题页模板 --- 刘志争
export const getTopicTems = function (data) {
    return request({
        url: '/userTenantCenter/getTopicTems',
        method: 'post',
        data
    })
}

// 专题页-新增 --- 刘志争
export const setNewPage = function (data) {
    return request({
        url: '/userTenantCenter/setNewPage',
        method: 'post',
        data
    })
}

// 专题页-内容查询 --- 刘志争
export const getTopicContent = function (data) {
    return request({
        url: '/userTenantCenter/getTopicContent',
        method: 'post',
        data
    })
}

// 专题页-内容管理保存--- 刘志争
export const saveTopicContent = function (data) {
    return request({
        url: '/userTenantCenter/saveTopicContent',
        method: 'post',
        data
    })
}